import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useErrorToast } from "../../components/Toast/Toast";

const OrganizationDisabledScreen: React.FC = () => {
  const navigate = useNavigate();
  const toastShown = useRef(false);

  useEffect(() => {
    // Prevent duplicate toast in React.StrictMode (development)
    if (!toastShown.current) {
      toastShown.current = true;
      // Show the error toast immediately
      useErrorToast("Your account has been disabled.");
    }

    // Redirect to login after 5 seconds
    const timer = setTimeout(() => {
      // Navigate to the root path which will trigger the authentication flow
      navigate("/");
    }, 5000);

    // Cleanup timer on component unmount
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <p className="text-lg text-gray-700">Redirecting in 5 seconds...</p>
      </div>
    </div>
  );
};

export default OrganizationDisabledScreen;
